<template>
    <div class="bill-main">        
        <div class="bill-tabbar-item body-padding">
            <div class="search-total">
                <div class="search-total__top">                    
                    <img src="../../assets/date.png" @click="show = true"/>
                    <span class="font37 color-2F">{{'合计¥' + total.total}}</span>
                </div>                
                <van-calendar v-model="show" type="range" @confirm="onConfirm" :min-date="minDate" :max-date="maxDate" color="#FE9329" />
            </div>
            <!-- <date-picker :hide-date.sync="hideDate" v-show="!hideDate" @close="closePicker"
                         @select-date="handleSelectDate"></date-picker> -->        
            <van-pull-refresh
                    v-model="loading"
                    style="overflow:scroll;padding-bottom: 1.7rem;height: 100%;box-sizing: border-box;"
                    @refresh="onRefresh">
                <van-list
                        :loading="loading"
                        :finished="finished"
                        @load="onLoad">
                    <router-link tag="div"
                                 v-for="(item, index) in list"
                                 :to="'/invite/order/details?id=' + item.orderNumber"
                                 :key="index">
                        <commission-item :item="item"/>
                    </router-link>
                </van-list>
            </van-pull-refresh>
            <div class="no-list" v-if="list.length === 0">暂无数据</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "UserExtendCommission",
        components: {            
            CommissionItem: () => import('./components/CommissionItem'),
            DatePicker: () => import('@/components/datepicker/DatePicker')
        },
        data() {
            return {
                show: false,                
                minDate: $moment().subtract(3, 'month').toDate(),
                maxDate: $moment().add(1, 'day').toDate(),              
                pageNum: 1,
                loading: false,
                list: [],
                total: {},
                finished: false,
                filterKey: {
                    logisticsCompanyId: this.$logisticsCompanyId,
                    startDate: this.formatDate(new Date()) + " 00:00:00",
                    endDate: this.formatDate($moment(new Date).add(1, 'day')) + " 23:59:59"
                }
            }
        },
        methods: {                    
            onLoad() {

            },
            onRefresh() {
                console.log('onRefresh')
                this.pageNum = 1
                this.loading = true
                this.getList(true)
            },
            getList(empty) {
                this.loading = true
                let params = {
                    page: {
                        pageNum: this.pageNum,
                        pageSize: 10
                    },
                    params: this.filterKey
                }
                this.$axios.post("extend/commission/bill/details", params).then(res => {
                    if (res.data.code === 200) {
                        if (empty) {
                            this.list = res.data.data.list
                        } else {
                            this.list = this.list.concat(res.data.data.list)
                        }
                        this.pageNum++
                        this.loading = false
                        this.finished = !res.data.data.hasNextPage
                        this.total = res.data.data.params
                    }
                }).finally(() => {
                    this.loading = false
                })
            },
            formatDate(date) {
                return $moment(date).format('YYYY-MM-DD')
            },
            onConfirm(date) {
                const [start, end] = date;                
                this.show = false;
                console.log(this.formatDate(start))
                this.filterKey.startDate = this.formatDate(start) + " 00:00:00"
                this.filterKey.endDate = this.formatDate($moment(end).subtract(1, 'day')) + " 23:59:59"
                this.getList(true)
                console.log('onConfirm')
            }
        },
        mounted() {           
            console.log('mounted') 
            this.loading = true
            this.getList(true)
        }
    }
</script>

<style scoped lang="less">

    .bill-main {
        display: flex;
        flex-direction: column;
        height: 100%;

        .bill-tabbar-item {
            position: relative;
            overflow: hidden;
            height: 100%;

            .search-total {
                background-color: #fff;
                margin-bottom: 0.13rem;

                .search-total__top {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                    padding: 0.31rem 0.32rem;
                    border-bottom: 1px solid #DBDBDB;

                    img {
                        width: 0.48rem;
                        height: 0.45rem;
                    }
                }

                .search-total__bottom {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                    padding: 0.31rem 0.32rem;
                }
            }
        }
    }


    .no-list {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 0.4rem;
        color: #8F8F8F;
    }
</style>
